import React from 'react';
import { connect } from 'react-redux';
import { Grid } from '@mui/material';
import SkeletonWrapper from '../../NewProductList/components/SkeletonWrapper/SkeletonWrapper';
import TableInc from '../../../shared-ui/TableInc';
import ButtonInc from '../../../shared-ui/ButtonInc';
import ModalInc from '../../../shared-ui/ModalInc';
import AlertDialog from '../../../components/AlertDialog/index.es6';
import {
  getOrgWebhookTemplatesRequest,
  createOrgWebhookTemplateRequest,
  updateOrgWebhookTemplateRequest,
  deleteOrgWebhookTemplateRequest,
  resetCreateOrgWebhookTemplateSuccess,
  resetCreateOrgWebhookTemplateError,
  resetUpdateOrgWebhookTemplateSuccess,
  resetUpdateOrgWebhookTemplateError,
  resetDeleteOrgWebhookTemplateSuccess,
  resetDeleteOrgWebhookTemplateError,
} from '../../OrganizationWebhookTemplates/Redux/actions';

class WebhookTemplatesTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCreate: false,
      showEdit: false,
      selectedTemplate: null,
      eventTypesStr: '',
      templateDataStr: '{}',
      templateDataError: '',
      isActive: true,
      showCreateSuccess: false, showCreateError: false,
      showUpdateSuccess: false, showUpdateError: false,
      showDeleteConfirm: false, templateToDelete: null,
      showDeleteSuccess: false, showDeleteError: false,
    };
  }

  componentWillMount() {
    this.props.dispatch(getOrgWebhookTemplatesRequest(this.props.organizationGuid));
  }

  componentDidUpdate(prevProps) {
    var d = this.props.orgWebhookTemplates;
    var p = prevProps.orgWebhookTemplates;
    var orgGuid = this.props.organizationGuid;
    if (d.created && !p.created) {
      this.setState({ showCreate: false, showCreateSuccess: true });
      this.props.dispatch(getOrgWebhookTemplatesRequest(orgGuid));
    }
    if (d.createError && !p.createError) { this.setState({ showCreateError: true }); }
    if (d.updated && !p.updated) {
      this.setState({ showEdit: false, showUpdateSuccess: true });
      this.props.dispatch(getOrgWebhookTemplatesRequest(orgGuid));
    }
    if (d.updateError && !p.updateError) { this.setState({ showUpdateError: true }); }
    if (d.deleted && !p.deleted) {
      this.setState({ showDeleteConfirm: false, templateToDelete: null, showDeleteSuccess: true });
      this.props.dispatch(getOrgWebhookTemplatesRequest(orgGuid));
    }
    if (d.deleteError && !p.deleteError) { this.setState({ showDeleteError: true }); }
  }

  validateJson(str) {
    try { JSON.parse(str); return ''; } catch (e) { return e.message; }
  }

  parseEventTypes(str) {
    return str.split(',').map(function(s) { return s.trim(); }).filter(Boolean);
  }

  handleCreate() {
    var err = this.validateJson(this.state.templateDataStr);
    if (err) { this.setState({ templateDataError: err }); return; }
    this.props.dispatch(createOrgWebhookTemplateRequest({
      organization_guid: this.props.organizationGuid,
      event_types: this.parseEventTypes(this.state.eventTypesStr),
      template_data: JSON.parse(this.state.templateDataStr),
      is_active: this.state.isActive,
    }));
  }

  openEdit(template) {
    this.setState({
      showEdit: true, selectedTemplate: template,
      eventTypesStr: (template.event_types || []).join(', '),
      templateDataStr: JSON.stringify(template.template_data || {}, null, 2),
      isActive: template.is_active !== false,
      templateDataError: '',
    });
  }

  handleUpdate() {
    var err = this.validateJson(this.state.templateDataStr);
    if (err) { this.setState({ templateDataError: err }); return; }
    var tmpl = this.state.selectedTemplate;
    this.props.dispatch(updateOrgWebhookTemplateRequest({
      guid: tmpl.guid,
      organization_guid: this.props.organizationGuid,
      event_types: this.parseEventTypes(this.state.eventTypesStr),
      template_data: JSON.parse(this.state.templateDataStr),
      is_active: this.state.isActive,
    }));
  }

  handleDelete() {
    var tmpl = this.state.templateToDelete;
    if (!tmpl) return;
    this.props.dispatch(deleteOrgWebhookTemplateRequest({
      guid: tmpl.guid,
      organization_guid: this.props.organizationGuid,
    }));
  }

  renderForm() {
    var state = this.state;
    return (
      <Grid container spacing={2} style={{ marginTop: 4 }}>
        <Grid item xs={12}>
          <label style={{ fontWeight: 600 }}>Event Types (comma-separated)</label>
          <input value={state.eventTypesStr}
            onChange={(e) => this.setState({ eventTypesStr: e.target.value })}
            placeholder="e.g. policy.created, claim.submitted"
            style={{ display: 'block', width: '100%', padding: 8, marginTop: 4, boxSizing: 'border-box' }} />
        </Grid>
        <Grid item xs={12}>
          <label style={{ fontWeight: 600 }}>Template Data (JSON — target URL, headers, etc.)</label>
          <textarea value={state.templateDataStr}
            onChange={(e) => this.setState({ templateDataStr: e.target.value, templateDataError: '' })}
            rows={8}
            style={{ display: 'block', width: '100%', padding: 8, marginTop: 4,
              boxSizing: 'border-box', fontFamily: 'monospace', fontSize: 12 }} />
          {state.templateDataError && <small style={{ color: 'red' }}>{state.templateDataError}</small>}
        </Grid>
        <Grid item xs={12}>
          <label>
            <input type="checkbox" checked={state.isActive}
              onChange={(e) => this.setState({ isActive: e.target.checked })}
              style={{ marginRight: 8 }} />
            Active
          </label>
        </Grid>
      </Grid>
    );
  }

  render() {
    var d = this.props.orgWebhookTemplates;
    var state = this.state;
    if (d.loading) { return <SkeletonWrapper loading={true} />; }
    var templates = d.list || [];

    return (
      <div>
        <Grid container justifyContent="space-between" alignItems="center" style={{ marginBottom: 12 }}>
          <Grid item><h3 style={{ margin: 0 }}>Webhook Templates</h3></Grid>
          <Grid item>
            <ButtonInc variant="contained" color="primary"
              onClick={() => this.setState({ showCreate: true, eventTypesStr: '',
                templateDataStr: '{}', isActive: true, templateDataError: '' })}>
              + Add Template
            </ButtonInc>
          </Grid>
        </Grid>
        {d.error && <p style={{ color: 'red' }}>{String(d.error)}</p>}
        <TableInc
          columns={[
            { title: 'Event Types', field: 'event_types',
              render: function(row) {
                return row.event_types ? row.event_types.join(', ') : '—';
              } },
            { title: 'Active', field: 'is_active',
              render: function(row) { return row.is_active ? 'Yes' : 'No'; } },
          ]}
          data={templates}
          actions={[
            { icon: 'edit', tooltip: 'Edit',
              onClick: function(e, row) { this.openEdit(row); }.bind(this) },
            { icon: 'delete', tooltip: 'Delete',
              onClick: function(e, row) {
                this.setState({ showDeleteConfirm: true, templateToDelete: row });
              }.bind(this) },
          ]}
          options={{ showTitle: false, actionsColumnIndex: -1, pageSize: 10 }}
        />

        <ModalInc modalTitle="Add Webhook Template" open={state.showCreate}
          close={() => this.setState({ showCreate: false })} fullWidth maxWidth="md"
          modalButtons={[
            <ButtonInc key="cancel" btnType="secondary" onClick={() => this.setState({ showCreate: false })}>Cancel</ButtonInc>,
            <ButtonInc key="save" variant="contained" color="primary" loading={d.creating} onClick={this.handleCreate.bind(this)}>Save</ButtonInc>,
          ]}>
          {this.renderForm()}
        </ModalInc>

        <ModalInc modalTitle="Edit Webhook Template" open={state.showEdit}
          close={() => this.setState({ showEdit: false })} fullWidth maxWidth="md"
          modalButtons={[
            <ButtonInc key="cancel" btnType="secondary" onClick={() => this.setState({ showEdit: false })}>Cancel</ButtonInc>,
            <ButtonInc key="save" variant="contained" color="primary" loading={d.updating} onClick={this.handleUpdate.bind(this)}>Save</ButtonInc>,
          ]}>
          {this.renderForm()}
        </ModalInc>

        {state.showCreateSuccess && (
          <AlertDialog show title="Created" type="success" showConfirm confirmBtnText="OK"
            onConfirm={() => { this.props.dispatch(resetCreateOrgWebhookTemplateSuccess()); this.setState({ showCreateSuccess: false }); }}>Template created.</AlertDialog>
        )}
        {state.showCreateError && (
          <AlertDialog show title="Error" type="danger" showConfirm confirmBtnText="OK"
            onConfirm={() => { this.props.dispatch(resetCreateOrgWebhookTemplateError()); this.setState({ showCreateError: false }); }}>
            {d.createError ? String(d.createError) : 'Error'}
          </AlertDialog>
        )}
        {state.showUpdateSuccess && (
          <AlertDialog show title="Updated" type="success" showConfirm confirmBtnText="OK"
            onConfirm={() => { this.props.dispatch(resetUpdateOrgWebhookTemplateSuccess()); this.setState({ showUpdateSuccess: false }); }}>Template updated.</AlertDialog>
        )}
        {state.showUpdateError && (
          <AlertDialog show title="Error" type="danger" showConfirm confirmBtnText="OK"
            onConfirm={() => { this.props.dispatch(resetUpdateOrgWebhookTemplateError()); this.setState({ showUpdateError: false }); }}>
            {d.updateError ? String(d.updateError) : 'Error'}
          </AlertDialog>
        )}
        {state.showDeleteConfirm && (
          <AlertDialog show title="Delete Template" type="warning" showConfirm showCancel
            confirmBtnText="Yes, Delete" cancelBtnText="Cancel" reverseConfirmAndCancelButtons
            onConfirm={this.handleDelete.bind(this)}
            onCancel={() => this.setState({ showDeleteConfirm: false, templateToDelete: null })}>
            Delete this webhook template?
          </AlertDialog>
        )}
        {state.showDeleteSuccess && (
          <AlertDialog show title="Deleted" type="success" showConfirm confirmBtnText="OK"
            onConfirm={() => { this.props.dispatch(resetDeleteOrgWebhookTemplateSuccess()); this.setState({ showDeleteSuccess: false }); }}>Template deleted.</AlertDialog>
        )}
        {state.showDeleteError && (
          <AlertDialog show title="Error" type="danger" showConfirm confirmBtnText="OK"
            onConfirm={() => { this.props.dispatch(resetDeleteOrgWebhookTemplateError()); this.setState({ showDeleteError: false }); }}>
            {d.deleteError ? String(d.deleteError) : 'Error'}
          </AlertDialog>
        )}
      </div>
    );
  }
}

export default connect(function(state) {
  return { orgWebhookTemplates: state.orgWebhookTemplatesData };
})(WebhookTemplatesTab);
